import RosterMailerError from './RosterMailerError';

// Superclass for errors involving API calls. Can include client failures or
// server errors
export default class ApiError extends RosterMailerError {}
